import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface AgentUserSaveAudioTemplateResponse {
  message: string;
  agent_id: string;
  user_id: number;
  is_agent: number;
}

export interface AgentUserSaveAudioTemplateRequest {
  userId: string,
  agentId: string,
  userAudioTemplateId: string
}

export class AgentUserSaveAudioTemplateData {
  id?: number;
}

const transformAndValidateData = (
  response: AgentUserSaveAudioTemplateResponse
): AgentUserSaveAudioTemplateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserSaveAudioTemplateData);
  } catch (error) {
    console.error("AgentUserSaveAudioTemplate data validation failed:", error.message);
    throw error;
  }
};

// 保存智能体用户音频（播客音频）
export const agentUserSaveAudioTemplate = async (templates: AgentUserSaveAudioTemplateRequest[]) => {
  const res = await api.post<AgentUserSaveAudioTemplateResponse>('/agent/user/save-audio-templates', {
    templates: templates.map(item => ({
      user_id: item.userId,
      agent_id: item.agentId,
      user_audio_template_id: item.userAudioTemplateId,
    })),
  });
  return transformAndValidateData(res.data);
};
